export default {
    formStep1: ({login, password, terms, mailing}) => ({login, password, terms, mailing}),
    formStep2: state => ({
        name         : state.name,
        firstname    : state.firstname,
        lastname     : state.lastname,
        phone_country: state.phone_country,
        phone_number : state.phone_number,
        country      : {code: state.country},
        lang         : state.lang
    }),
    finalForm: state => state
}